import axios from "axios";
import { formatShopifyIdForTracking } from "~lib/track";
const backInStockNotification = async (
  type: string,
  productId: string,
  variantId: string,
  client: string
) => {
  if (type === "E-mail") {
    return axios.get(
      `https://app.backinstock.org/stock_notification/create.json?shop=natural-heroes-nl.myshopify.com&notification[email]=${client}&notification[product_no]=${formatShopifyIdForTracking(
        productId
      )}&variant[variant_no]=${formatShopifyIdForTracking(variantId)}`
    );
  }
  return axios.get(
    `https://app.backinstock.org/stock_notification/create.json?shop=natural-heroes-nl.myshopify.com&notification[phone_number]=${client}&notification[channel]=sms&notification[product_no]=${formatShopifyIdForTracking(
      productId
    )}&variant[variant_no]=${formatShopifyIdForTracking(variantId)}`
  );
};
export default backInStockNotification;
